import { useEffect } from "react";

export const useInitCacheSettings = (cacheSettings: string[]) => {
  const initCacheSetting = (cacheSetting: string) => {
    const cache = localStorage.getItem(cacheSetting);
    if (!cache) {
      localStorage.setItem(cacheSetting, String(true));
    }
  };

  useEffect(() => {
    cacheSettings.forEach(setting => initCacheSetting(setting));
  }, []);
};
